const translations = {
  "nav.pricing": "Tarifs",
  "nav.features": "Fonctionnement",
  "nav.support": "Support",
  "nav.contact": "Contacter",
  "hero.badge": "Garantie satisfait ou remboursé",
  "hero.title1": "Votre cinéma TV",
  "hero.title2": "illimité à la maison !",
  "hero.desc": "Profitez d'un accès illimité à <b>+35 000 chaînes en direct</b> et <b>+70 000 films & séries</b> en qualité HD/4K — <b>0 coupure, 0 freeze</b>. Notre équipe est disponible <b>7j/7 de 10h à 23h</b> pour vous accompagner. Testez gratuitement et rejoignez des milliers de clients satisfaits !",
  "hero.cta_primary": "Tester maintenant",
  "hero.cta_secondary": "Nous contacter",
  "hero.rating_text": "– +2 300 clients",
  "hero.feature_trial": "Test gratuit 24h",
  "hero.feature_channels": "+35 000 chaînes",
  "hero.feature_vod": "Films & séries 4K",
  "hero.feature_stable": "Service stable 24/7",
  "hero.discover": "🔥 Découvrir nos offres",
  "social.badge": "Preuves de Paiement",
  "social.title1": "+10 000 Clients",
  "social.title2": "Satisfaits",
  "social.desc": "Des preuves réelles de nos clients — paiements vérifiés et abonnements activés en direct",
  "social.stat1_val": "10 000+",
  "social.stat1_label": "Clients Satisfaits",
  "social.stat2_val": "4.9/5",
  "social.stat2_label": "Note Moyenne",
  "social.stat3_val": "98%",
  "social.stat3_label": "Taux de Satisfaction",
  "pricing.badge": "💎 Offres Exclusives",
  "pricing.title": "Abonnement Streaming Premium",
  "pricing.subtitle": "🎥 Accès illimité à +40 000 Films & Séries + 35 000 Chaînes TV en direct - Qualité 4K garantie sans coupure !",
  "pricing.premium_badge": "PREMIUM",
  "pricing.premium_title": "Offre Premium",
  "pricing.premium_sub": "L'essentiel du streaming de qualité",
  "pricing.gold_badge": "PREMIUM GOLD",
  "pricing.gold_title": "Offre Premium",
  "pricing.gold_title2": "GOLD",
  "pricing.gold_sub": "L'expérience ultime du streaming • Tout inclus",
  "pricing.gold_desc1": "Profitez d'un accès illimité à plus de <b>35 000 chaînes</b> en direct et plus de <b>70 000 films et séries</b>",
  "pricing.recommended": "RECOMMANDÉ",
  "pricing.months3": "3 Mois",
  "pricing.months6": "6 Mois",
  "pricing.months12": "12 Mois",
  "pricing.months1": "1 Mois",
  "pricing.per_month1": "79 DH/mois",
  "pricing.per_month3": "50 DH/mois",
  "pricing.per_month6": "33 DH/mois",
  "pricing.per_month12": "25 DH/mois",
  "pricing.per_month1g": "99 DH/mois",
  "pricing.per_month3g": "66 DH/mois",
  "pricing.per_month6g": "50 DH/mois",
  "pricing.per_month12g": "42 DH/mois",
  "pricing.bonus": "🎁 2ème abo à 45 USD",
  "pricing.replay": "Replay 24h",
  "pricing.btn_test": "🎁 Tester",
  "pricing.btn_choose": "🔥 Choisir",
  "pricing.card_discount": "💳 -10% de réduction si paiement par carte bancaire",
  "pricing.payment_title": "Modes de paiement acceptés",
  "pricing.secure": "Paiement sécurisé",
  "pricing.instant": "Activation instantanée",
  "pricing.dedicated": "Support dédié",
  "pricing.premium_compare": "Premium : 1 App",
  "pricing.gold_compare": "Gold : 3 Apps sur le même appareil",
  "pricing.f1": "Qualité HD / 4K sur tous vos écrans",
  "pricing.f2": "1 Application IPTV incluse",
  "pricing.f3": "1 Appareil connecté simultanément",
  "pricing.f4": "Activation immédiate en 5 min",
  "pricing.f5": "Support WhatsApp 7j/7",
  "pricing.f6": "Compatible Smart TV, Box, Mobile, PC",
  "pricing.f7": "Mises à jour automatiques",
  "pricing.f8": "Chaînes internationales incluses",
  "pricing.gf1": "Qualité 4K Ultra HD premium",
  "pricing.gf2": "3 Applications IPTV incluses",
  "pricing.gf3": "1 Appareil connecté simultanément",
  "pricing.gf4": "Technologie Anti-Freeze exclusive",
  "pricing.gf5": "Replay 24h sur quelques chaînes",
  "pricing.gf6": "Guide EPG électronique complet",
  "pricing.gf7": "Support prioritaire 24/7",
  "pricing.gf8": "Compatible tous les appareils",
  "pricing.gf9": "Mises à jour automatiques",
  "pricing.gf10": "Contenu international premium",
  "pricing.gf11": "VOD Netflix, Prime, Disney+…",
  "pricing.gf12": "Activation immédiate en 5 min",
  "pricing.s1_val": "+25 000", "pricing.s1_sub": "Chaînes HD/4K",
  "pricing.s2_val": "+35 000", "pricing.s2_sub": "Films & Séries",
  "pricing.s3_val": "1 App", "pricing.s3_sub": "Incluse",
  "pricing.s4_val": "Stable", "pricing.s4_sub": "Connexion",
  "pricing.gs1_val": "+35 000", "pricing.gs1_sub": "Chaînes 4K",
  "pricing.gs2_val": "+70 000", "pricing.gs2_sub": "Films & Séries",
  "pricing.gs3_val": "3 Apps", "pricing.gs3_sub": "Sur 1 appareil",
  "pricing.gs4_val": "Anti-Freeze", "pricing.gs4_sub": "Technologie",
  "why.badge": "AVANTAGES",
  "why.title": "Pourquoi Nous Choisir !",
  "why.desc": "7 ans d'expérience dans le streaming premium avec des milliers de clients satisfaits",
  "why.exp": "EXPÉRIENCE DE",
  "why.exp_val": "7 Ans",
  "why.b1_title": "Garantie Satisfait ou Remboursé",
  "why.b1_desc": "Si vous n'êtes pas entièrement satisfait la première semaine, nous vous remboursons intégralement—sans questions. Votre satisfaction est notre priorité.",
  "why.b2_title": "Activation Instantanée",
  "why.b2_desc": "Une fois inscrit, vous obtenez un accès instantané avec vos identifiants de connexion. Commencez à regarder immédiatement.",
  "why.b3_title": "Meilleurs Prix du Marché",
  "why.b3_desc": "Vous ne trouverez pas un meilleur rapport qualité-prix avec de tels standards de qualité. Prix imbattables.",
  "why.b4_title": "Top Chaînes & VoD",
  "why.b4_desc": "Notre service VoD vous donne accès aux derniers films et séries. Chaînes live et pay-per-view disponibles.",
  "why.b5_title": "Support Client 24/7",
  "why.b5_desc": "Nous sommes disponibles 24h/24. Que ce soit le jour ou la nuit, notre équipe est prête à vous aider. Contactez-nous à tout moment.",
  "devices.badge": "📺 Compatibilité",
  "devices.title1": "Compatible avec",
  "devices.title2": "tous vos appareils",
  "devices.desc": "Installez en moins de 2 minutes sur n'importe quel appareil et profitez du streaming partout.",
  "devices.note": "✅ Installation guidée par notre équipe technique • ✅ Assistance à distance disponible",
  "devices.d1": "Smart TV", "devices.d1s": "Samsung, LG, Sony, Philips…",
  "devices.d2": "Android TV", "devices.d2s": "Box Android, Nvidia Shield…",
  "devices.d3": "Fire Stick", "devices.d3s": "Amazon Fire TV Stick 4K",
  "devices.d4": "Smartphone", "devices.d4s": "iOS & Android",
  "devices.d5": "Tablette", "devices.d5s": "iPad, Samsung Tab…",
  "devices.d6": "Ordinateur", "devices.d6s": "Windows, Mac, Linux",
  "content.title": "Sports, Films, Séries & bien plus",
  "content.desc": "Un catalogue complet pour toute la famille — du sport en direct au divertissement illimité.",
  "content.brands_title": "Découvrez un monde de divertissement sans fin avec 4K Dream",
  "content.brands_desc": "Achetez un abonnement et arrêtez de gaspiller de l'argent sur plusieurs abonnements. Nous proposons toute la gamme de contenus, de films et de séries télévisées, le tout sous un même toit virtuel : 4K Dream",
  "content.premium_title": "Contenus de Divertissement Premium",
  "content.sports_title": "Sports & Ligues Internationales",
  "content.movies_title": "Films & Séries Populaires",
  "content.c1_title": "⚽ Sports en Direct",
  "content.c1_desc": "Tous les matchs de foot, tennis, boxe, F1 — BeIN, Canal+, DAZN et plus encore.",
  "content.c2_title": "🎬 Films & Cinéma",
  "content.c2_desc": "Des milliers de films en 4K — blockbusters, classiques, et nouveautés chaque semaine.",
  "content.c3_title": "📺 Séries & VOD",
  "content.c3_desc": "Netflix, Disney+, Prime Video et plus — toutes vos séries préférées en un seul endroit.",
  "content.c4_title": "🌍 Chaînes Internationales",
  "content.c4_desc": "Plus de 150 pays couverts — chaînes arabes, européennes, africaines, américaines.",
  "content.c5_title": "👶 Contenu Enfants",
  "content.c5_desc": "Des centaines de chaînes et dessins animés pour vos enfants — en toute sécurité.",
  "guarantee.title": "Garantie",
  "guarantee.title2": "Satisfait ou Remboursé",
  "guarantee.desc": "Testez notre service pendant <b>7 jours</b>. Si vous n'êtes pas satisfait, nous vous remboursons intégralement — sans questions.",
  "guarantee.g1_title": "Remboursement 100%",
  "guarantee.g1_desc": "Remboursement intégral si le service ne vous convient pas",
  "guarantee.g2_title": "7 Jours pour Tester",
  "guarantee.g2_desc": "Une semaine complète pour découvrir toutes les fonctionnalités",
  "guarantee.g3_title": "Support Dédié",
  "guarantee.g3_desc": "Notre équipe vous accompagne tout au long de votre essai",
  "whydigi.title": "Pourquoi Choisir 4K Dream ?",
  "whydigi.desc": "Découvrez tous les avantages qui font de nous le leader du streaming IPTV au Maroc",
  "whydigi.f1_title": "Garantie Satisfait ou Remboursé",
  "whydigi.f1_desc": "7 jours pour tester, remboursement intégral si vous n'êtes pas satisfait",
  "whydigi.f2_title": "Activation Instantanée",
  "whydigi.f2_desc": "Recevez vos accès en moins de 5 minutes après paiement",
  "whydigi.f3_title": "Support VIP 7j/7",
  "whydigi.f3_desc": "Assistance technique disponible de 10h à 23h tous les jours",
  "whydigi.f4_title": "Replay 7 Jours",
  "whydigi.f4_desc": "Revoir vos émissions des 7 derniers jours quand vous voulez",
  "whydigi.f5_title": "Mises à Jour Automatiques",
  "whydigi.f5_desc": "Nouvelles chaînes et contenus ajoutés régulièrement",
  "whydigi.f6_title": "Anti-Freeze Technologie",
  "whydigi.f6_desc": "Serveurs optimisés pour un streaming sans coupure",
  "whydigi.f7_title": "Qualité 4K Ultra HD",
  "whydigi.f7_desc": "Image cristalline sur toutes vos chaînes favorites",
  "world.badge": "Couverture Internationale",
  "world.title1": "Streaming TV",
  "world.title2": "Partout dans le Monde",
  "world.desc": "Peu importe où vous vous trouvez, notre service est disponible à l'international.",
  "trial.title": "Test Gratuit 24h",
  "trial.desc": "Testez notre service pendant 24h gratuitement. Aucun engagement, aucune carte de crédit requise.",
  "trial.form_title": "Contact Direct WhatsApp",
  "trial.success_title": "Demande envoyée !",
  "trial.success_desc": "Nous vous contacterons très bientôt sur WhatsApp.",
  "trial.name_label": "Nom complet",
  "trial.name_placeholder": "Votre nom complet",
  "trial.phone_label": "Numéro de téléphone",
  "trial.phone_placeholder": "Votre numéro de téléphone",
  "trial.city_label": "Ville",
  "trial.city_placeholder": "Votre ville",
  "trial.submit": "Obtenir le Test via WhatsApp",
  "trial.sending": "Envoi...",
  "trial.h1": "24h Complètes",
  "trial.h1d": "Accès illimité pendant 24 heures à tous nos services",
  "trial.h2": "Sans Engagement",
  "trial.h2d": "Aucune carte de crédit requise, annulation automatique",
  "trial.h3": "Activation Instantanée",
  "trial.h3d": "Recevez vos identifiants par email en moins de 5 minutes",
  "trial.what_title": "Ce que vous pouvez tester :",
  "trial.w1": "Tous les bouquets\nCanal+, OCS, Paramount+, Sport...",
  "trial.w2": "Bibliothèque Complète\n20 000+ films et séries",
  "trial.w3": "Qualité Premium\nQualité 4K, Full HD",
  "faq.badge": "FAQ",
  "faq.title1": "Questions",
  "faq.title2": "Fréquentes",
  "faq.desc": "Tout ce que vous devez savoir avant de vous abonner",
  "faq.more": "Vous avez d'autres questions ?",
  "faq.cta": "Contactez-nous sur WhatsApp",
  "faq.q1": "Comment fonctionne votre service de streaming ?",
  "faq.a1": "Notre service IPTV vous permet de regarder +35 000 chaînes en direct et +70 000 films & séries via internet sur tous vos appareils. Après paiement, vous recevez vos identifiants en 5 minutes.",
  "faq.q2": "Sur quels appareils puis-je utiliser le service ?",
  "faq.a2": "Compatible Smart TV (Samsung, LG, Sony), Android TV, Fire Stick, smartphones iOS & Android, tablettes, et ordinateurs Windows/Mac/Linux.",
  "faq.q3": "Quelle vitesse internet est nécessaire ?",
  "faq.a3": "Minimum 10 Mbps pour la HD, 25 Mbps pour la 4K. Une connexion fibre ou 4G/5G est recommandée.",
  "faq.q4": "Comment fonctionne le test gratuit de 24h ?",
  "faq.a4": "Remplissez le formulaire ci-dessus. Nous vous envoyons vos identifiants de test via WhatsApp en moins de 5 minutes, sans carte de crédit requise.",
  "faq.q5": "Le service est-il fiable ? Y a-t-il des coupures ?",
  "faq.a5": "Nos serveurs utilisent la technologie Anti-Freeze avec 99.9% de disponibilité. Nous avons des serveurs redondants pour garantir un streaming stable.",
  "faq.q6": "Quels modes de paiement acceptez-vous ?",
  "faq.a6": "Visa/Mastercard (-10%), virement bancaire, Wafacash, CashPlus, PayPal, Remitly, Western Union, Binance et compte Europe.",
  "faq.q7": "Combien de temps dure l'activation ?",
  "faq.a7": "Activation immédiate en moins de 5 minutes après confirmation du paiement, 7j/7 de 10h à 23h.",
  "faq.q8": "Puis-je utiliser le service à l'étranger ?",
  "faq.a8": "Oui, le service fonctionne dans le monde entier : Europe, Afrique, Amérique, Moyen-Orient. Où que vous soyez, accès garanti.",
  "support.title": "Support Client 24/7",
  "support.desc": "Une équipe dédiée pour vous accompagner à chaque étape de votre expérience digitale",
  "support.channels_title": "Contactez-nous par Votre Canal Préféré",
  "support.cta_whatsapp": "Contacter le Support",
  "support.note": "💬 WhatsApp • 📞 Téléphone • 📧 Email • 🏠 À domicile",
  "support.s1_title": "WhatsApp",
  "support.s1_desc": "Support instantané via WhatsApp",
  "support.s1_speed": "< 5 min",
  "support.s1_hours": "24/7",
  "support.s2_title": "Téléphone",
  "support.s2_desc": "Assistance téléphonique directe",
  "support.s2_speed": "Immédiat",
  "support.s2_hours": "8h-23h",
  "support.s3_title": "Email",
  "support.s3_desc": "Support technique par email",
  "support.s3_speed": "< 2h",
  "support.s3_hours": "24/7",
  "support.s4_title": "À Domicile",
  "support.s4_desc": "Intervention technique chez vous",
  "support.s4_speed": "24-48h",
  "support.s4_hours": "Lun-Sam",
  "support.s4_contact": "Sur RDV",
  "cta.title": "Commencez à Regarder Aujourd'hui",
  "cta.desc": "Rejoignez des milliers de clients satisfaits. Activez votre abonnement en 5 minutes et profitez de +25 000 chaînes.",
  "cta.expires": "Offre promotionnelle expire dans",
  "cta.btn1": "Tester maintenant",
  "cta.btn2": "Tester gratuitement 24h",
  "cta.note": "✅ Paiement sécurisé • ✅ Activation instantanée • ✅ Garantie 7 jours",
  "footer.services": "Services",
  "footer.contact": "Contact",
  "footer.coverage": "Couverture",
  "footer.legal": "Légal",
  "footer.copyright": "© 2024 4K Dream - Tous droits réservés.",
  "footer.s1": "Abonnements Premium",
  "footer.s2": "Films & Séries 4K",
  "footer.s3": "Sport en Direct",
  "footer.s4": "Support 24/7",
  "footer.cov1": "🌍 Europe",
  "footer.cov2": "🌍 Amérique",
  "footer.cov3": "🌍 Afrique",
  "footer.cov4": "🌍 Monde entier",
  "footer.l1": "À Propos",
  "footer.l2": "Conditions Générales",
  "footer.l3": "Politique de Confidentialité",
  "footer.l4": "Politique de Remboursement",
  "footer.l5": "Contact",
};

export default translations;
